import {combineReducers } from "redux";
import language  from './language/LanguageReducer';
import product  from './product/ProductReducer';

export default combineReducers({
    language: language,
    product: product
})